export const BriefField = ({ label, num, children }) => (
  <label className="block">
    <span className="label mb-2 block text-[#8a8a8a]">
      <span className="mr-2 text-[#d4ff00]">{num}</span>
      {label}
    </span>
    {children}
  </label>
);